var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    {
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [
              _c(
                "div",
                [
                  _c("el-button", { attrs: { type: "primary" } }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("buttons.Confirm")) +
                        "\n      "
                    ),
                  ]),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card_body" },
        [
          _c(
            "el-form",
            {
              ref: "periodForm",
              attrs: {
                model: _vm.periodData,
                "label-position": "right",
                "label-width": "90px",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: false,
                      expression: "false",
                    },
                  ],
                  attrs: { label: "ID", prop: "orgId" },
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.periodData.orgId,
                      callback: function ($$v) {
                        _vm.$set(_vm.periodData, "orgId", $$v)
                      },
                      expression: "periodData.orgId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: { label: _vm.$t("tableFrom.Domain"), prop: "domain" },
                },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.periodData.domain,
                      callback: function ($$v) {
                        _vm.$set(_vm.periodData, "domain", $$v)
                      },
                      expression: "periodData.domain",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: _vm.$t("tableFrom.ValidityPeriod") } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 11 } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "date",
                          placeholder: _vm.$t("tableFrom.SelectDate"),
                        },
                        model: {
                          value: _vm.periodData.startDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.periodData, "startDate", $$v)
                          },
                          expression: "periodData.startDate",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-col", { staticClass: "line", attrs: { span: 2 } }, [
                    _vm._v("-"),
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 11 } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "date",
                          placeholder: _vm.$t("tableFrom.SelectTime"),
                        },
                        model: {
                          value: _vm.periodData.expireDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.periodData, "expireDate", $$v)
                          },
                          expression: "periodData.expireDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: _vm.$t("tableFrom.ReDays"),
                    prop: "reserveDay",
                  },
                },
                [
                  _c("el-input-number", {
                    model: {
                      value: _vm.periodData.reserveDay,
                      callback: function ($$v) {
                        _vm.$set(_vm.periodData, "reserveDay", $$v)
                      },
                      expression: "periodData.reserveDay",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "密码复杂度", prop: "passwordComplexity" } },
                [
                  _c(
                    "el-checkbox",
                    {
                      model: {
                        value: _vm.periodData.passwordComplexity,
                        callback: function ($$v) {
                          _vm.$set(_vm.periodData, "passwordComplexity", $$v)
                        },
                        expression: "periodData.passwordComplexity",
                      },
                    },
                    [_vm._v("是否启用")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }